import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { pluck } from 'rxjs/operators';
import { TranslationService } from '../../core/services/translation.service';
import { AuthService } from '../auth.service';
import { ResetPasswordInterface } from './reset-password.interface';
import { APP_TITLE_KEY } from '../../dashboard/dashboard.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  hash: string;
  resetPassword$: Observable<boolean>;
  done = false;
  fieldErrors: any;

  constructor(
    private authService: AuthService,
    private activeRoute: ActivatedRoute,
    private translationService: TranslationService,
    private titlesService: Title
  ) { }

  ngOnInit() {
    this.hash = this.activeRoute.snapshot.params['hash'];
    this.resetPassword$ = this.activeRoute.data.pipe(pluck('resetPassword'));
    const title = this.translationService.getTranslationSync(APP_TITLE_KEY);
    this.titlesService.setTitle(title);
  }

  async onResetPassword(resetPassword: ResetPasswordInterface) {
    this.fieldErrors = null;
    try {
      await this.authService.resetPassword(this.hash, resetPassword.password, resetPassword.passwordRepeat);
      this.done = true;
    } catch (errors) {
      this.fieldErrors = errors;
    }
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/auth/reset-password/reset-password.component.ts